module.exports = __webpack_public_path__ + "img/ricoh-logo.f6fbfc39.svg";